import * as React from 'react';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { Comment } from '../models/card';
import * as Utility from '../utils/Utility';

interface CommentArchieveProps {
    setReputation?: Function;
    comment: Comment;
    index?: number;
}

interface CommentArchieveState {
    isFavourite: boolean;
}

class CommentArchieve extends React.PureComponent<CommentArchieveProps, CommentArchieveState> {
    constructor(props: any) {
        super(props);
        this.state = { isFavourite: false };
    }

    onHoverFavourite = () => {
        const { isFavourite } = this.state;
        this.setState({isFavourite: !isFavourite});
    }

    onClickFavourite = () => {
        this.props.setReputation && this.props.setReputation();
    }

    render() {
        const { isFavourite } = this.state;
        const { comment, index } = this.props;
        const reputaionFormat = Utility.numberWithCommas(comment.reputation);
        return (
            <React.Fragment>
                <hr/>
                <div className={`${index !== 0 ? 'archieve-comment': ''} row`} >
                    <div className="col-6">
                        {comment.data}
                    </div>
                    <div className="col-6">
                        <span style={{ float: 'right' }}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                { !isFavourite && <span style={{cursor: 'pointer'}} onMouseEnter={() => {this.onHoverFavourite()}}><FavoriteBorderOutlinedIcon /></span> }
                                { isFavourite && <span style={{cursor: 'pointer'}} onClick={()=> {this.onClickFavourite()}} onMouseLeave={() => {this.onHoverFavourite()}}><FavoriteIcon /></span> }
                                <span style={{marginLeft: '10px'}}>{reputaionFormat} Reputations</span>
                            </div>
                        </span>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default CommentArchieve;